import { defineMessages } from 'react-intl';

export default function Messages() {
  const messages = defineMessages({
    serial_number_label_main_screen_text: {
      id: 'serial_number_label_main_screen_text',
      defaultMessage: "Serial number",
      description: '',
    },
    address_label_main_screen_text: {
      id: 'address_label_main_screen_text',
      defaultMessage: "Address",
      description: '',
    },
    address_noinformation_main_screen_text: {
      id: 'address_noinformation_main_screen_text',
      defaultMessage: "No information",
      description: '',
    },
    address_placeholder_main_screen_text: {
      id: 'address_placeholder_main_screen_text',
      defaultMessage: "Enter a new address",
      description: '',
    },
    additional_information_label_main_screen_text: {
      id: 'additional_information_label_main_screen_text',
      defaultMessage: "Name",
      description: '',
    },
    comment_noinformation_main_screen_text: {
      id: 'comment_noinformation_main_screen_text',
      defaultMessage: "No information",
      description: '',
    },
    comment_placeholder_main_screen_text: {
      id: 'comment_placeholder_main_screen_text',
      defaultMessage: "Enter a new additional information",
      description: '',
    },
    bottle_configuration_main_screen_text: {
      id: 'bottle_configuration_main_screen_text',
      defaultMessage: "Bottle configuration",
      description: '',
    },
    valve_main_screen_text: {
      id: 'valve_main_screen_text',
      defaultMessage: "Valve",
      description: '',
    },
    save_changes_button_main_screen_text: {
      id: 'save_changes_button_main_screen_text',
      defaultMessage: "Save changes",
      description: '',
    },
    send_command_command_popup: {
      id: 'send_command_command_popup',
      defaultMessage: "Command",
      description: '',
    },
    send_command_value_popup: {
      id: 'send_command_value_popup',
      defaultMessage: "Value",
      description: '',
    },
    pairing_cofirmation_info_text: {
      id: 'pairing_cofirmation_info_text',
      defaultMessage: "To pair a new sensor, click the `Add` button <br/>The device must be active and assigned to the user account.<br/>To activate (wake up) the sensor, open the top cover of the housing and press the button. ",
      description: '',
    },
    pairing_confirmation_text: {
      id: 'pairing_confirmation_text',
      defaultMessage: "Add",
      description: '',
    },
    pairing_start_button_text: {
      id: 'pairing_start_button_text',
      defaultMessage: "Pair with ",
      description: '',
    },
    pairing_already_connected_list_text: {
      id: 'pairing_already_connected_list_text',
      defaultMessage: "List of paired floor sensors:",
      description: '',
    },
    pairing_available_floor_sensors: {
      id: 'pairing_available_floor_sensors',
      defaultMessage: "Available floor sensors",
      description: '',
    },
    pairing_paired_on_device: {
      id: 'pairing_paired_on_device',
      defaultMessage: "Paired only on device",
      description: '',
    },
    pairing_paired_on_device_and_service: {
      id: 'pairing_paired_on_device_and_service',
      defaultMessage: "Paired locally and via web service",
      description: '',
    },
    pairing_paired_on_service: {
      id: 'pairing_paired_on_service',
      defaultMessage: "Paired only with web service",
      description: '',
    },
    pairing_pair_only_in_service: {
      id: 'pairing_pair_only_in_service',
      defaultMessage: "The sensor cannot be paired with the device via the local network (WiFi).<br/>Do you want to continue and combine the devices only via the internet web application?",
      description: '',
    },
    pairing_status_active: {
      id: 'pairing_status_active',
      defaultMessage: "Pairing in progress...",
      description: '',
    },
    pairing_status_not_paired: {
      id: 'pairing_status_not_paired',
      defaultMessage: "Not paired",
      description: '',
    },
    pairing_status_paired: {
      id: 'pairing_status_paired',
      defaultMessage: "Paired",
      description: '',
    },
    pairing_no_floor_sensors: {
      id: 'pairing_no_floor_sensors',
      defaultMessage: "No available floor sensors",
      description: '',
    },
    pairing_connected_safetech_to_softeners_text: {
      id: 'pairing_connected_safetech_to_softeners_text',
      defaultMessage: "List of connected SafeTech devices",
      description: '',
    },
    pairing_connected_softeners_to_safetech_text: {
      id: 'pairing_connected_softeners_to_safetech_text',
      defaultMessage: "List of connected softeners",
      description: '',
    },
    create_ownership_popup_title: {
      id: 'create_ownership_popup_title',
      defaultMessage: "Add device ownership",
      description: '',
    },
    create_ownership_popup_msg: {
      id: 'create_ownership_popup_msg',
      defaultMessage: "Device has been added to your account",
      description: '',
    },
    remove_ownership_popup_title: {
      id: 'remove_ownership_popup_title',
      defaultMessage: "Remove device from user",
      description: '',
    },
    remove_ownership_popup_msg: {
      id: 'remove_ownership_popup_msg',
      defaultMessage: "Device has been removed",
      description: '',
    },
    save_password_popup_title: {
      id: 'save_password_popup_title',
      defaultMessage: "New password",
      description: '',
    },
    save_password_popup_msg: {
      id: 'save_password_popup_msg',
      defaultMessage: "New password has been set",
      description: '',
    },
    blocked_interaction_popup_title: {
      id: 'blocked_interaction_popup_title',
      defaultMessage: "Action is blocked",
      description: '',
    },
    blocked_interaction_popup_msg: {
      id: 'blocked_interaction_popup_msg',
      defaultMessage: "Action is blocked",
      description: '',
    },
    edit_personal_data_popup_title: {
      id: 'edit_personal_data_popup_title',
      defaultMessage: "Personal data",
      description: '',
    },
    edit_personal_data_popup_msg: {
      id: 'edit_personal_data_popup_msg',
      defaultMessage: "Your personal data have been saved",
      description: '',
    },
    save_notification_config_popup_title: {
      id: 'save_notification_config_popup_title',
      defaultMessage: "Email notifications",
      description: '',
    },
    save_notification_config_popup_msg: {
      id: 'save_notification_config_popup_msg',
      defaultMessage: "Your email notifications have been saved",
      description: '',
    },
    add_ownership_failure_popup_title: {
      id: 'add_ownership_failure_popup_title',
      defaultMessage: "Add device to user",
      description: '',
    },
    add_ownership_failure_popup_msg: {
      id: 'add_ownership_failure_popup_msg',
      defaultMessage: "We could not add device to user",
      description: '',
    },
    remove_ownership_failure_popup_title: {
      id: 'remove_ownership_failure_popup_title',
      defaultMessage: "Remove device from user",
      description: '',
    },
    remove_ownership_failure_popup_msg: {
      id: 'remove_ownership_failure_popup_msg',
      defaultMessage: "We could not remove user assigment",
      description: '',
    },
    no_users_found_title: {
      id: 'no_users_found_title',
      defaultMessage: "No users found",
      description: '',
    },
    edit_popup_users_text: {
      id: 'edit_popup_users_text',
      defaultMessage: "users",
      description: '',
    },
    edit_popup_user_text: {
      id: 'edit_popup_user_text',
      defaultMessage: "user",
      description: '',
    },
    add_device_incorrect_serial_number_title: {
      id: 'add_device_incorrect_serial_number_title',
      defaultMessage: "Serial number of the device is not correct",
      description: '',
    },
    add_device_incorrect_serial_number_msg: {
      id: 'add_device_incorrect_serial_number_msg',
      defaultMessage: "Correct serial number has 9 digits and is preceded by single character (C/M/L or S). Serial number of the device can be found on a sticker in its back or in menu at Info/Status screen",
      description: '',
    },
    add_device_not_found_title: {
      id: 'add_device_not_found_title',
      defaultMessage: "Device has not been found",
      description: '',
    },
    add_device_not_found_msg: {
      id: 'add_device_not_found_msg',
      defaultMessage: "Please check if device is powered on, connected to the network and has Internet access",
      description: '',
    },
    add_device_unavailable_title: {
      id: 'add_device_unavailable_title',
      defaultMessage: "Device is unavailable",
      description: '',
    },
    add_device_unavailable_msg: {
      id: 'add_device_unavailable_msg',
      defaultMessage: "Device  assigned to other user. To assign to your account , you need to remove it from current assigned account",
      description: '',
    },
    add_device_error_title: {
      id: 'add_device_error_title',
      defaultMessage: "Error occured",
      description: '',
    },
    add_device_error_msg: {
      id: 'add_device_error_msg',
      defaultMessage: "Contact administrator",
      description: '',
    },
    add_device_to_installation_title: {
      id: 'add_device_to_installation_title',
      defaultMessage: "Protection installation",
      description: '',
    },
    add_device_to_installation_msg: {
      id: 'add_device_to_installation_msg',
      defaultMessage: "Device has been added",
      description: '',
    },
    add_device_to_installation_already_exists_title: {
      id: 'add_device_to_installation_already_exists_title',
      defaultMessage: "Protedction installation already exists",
      description: '',
    },
    add_device_to_installation_already_exists_msg: {
      id: 'add_device_to_installation_already_exists_msg',
      defaultMessage: "Installation already exists",
      description: '',
    },
    add_device_to_installation_not_exist_title: {
      id: 'add_device_to_installation_not_exist_title',
      defaultMessage: "Protection installation: device does not exist",
      description: '',
    },
    add_device_to_installation_not_exist_msg: {
      id: 'add_device_to_installation_not_exist_msg',
      defaultMessage: "You can not add this device to installation, because it not exist or type is wrong",
      description: '',
    },
    remove_device_from_installation_title: {
      id: 'remove_device_from_installation_title',
      defaultMessage: "Device has been deleted",
      description: '',
    },
    remove_device_from_installation_msg: {
      id: 'remove_device_from_installation_msg',
      defaultMessage: "Device has been deleted from installation",
      description: '',
    },
    remove_device_from_installation_error_title: {
      id: 'remove_device_from_installation_error_title',
      defaultMessage: "Device has not been deleted",
      description: '',
    },
    remove_device_from_installation_error_msg: {
      id: 'remove_device_from_installation_error_msg',
      defaultMessage: "You can not delete device from this installation",
      description: '',
    },
    salt_sensor_history_yes: {
      id: 'salt_sensor_history_yes',
      defaultMessage: "Yes",
      description: '',
    },
    salt_sensor_history_no: {
      id: 'salt_sensor_history_no',
      defaultMessage: "No",
      description: '',
    },
    medium_01_softener_text: {
      id: 'medium_01_softener_text',
      defaultMessage: "Lewatit 1567",
      description: '',
    },
    medium_02_softener_text: {
      id: 'medium_02_softener_text',
      defaultMessage: "Birm",
      description: '',
    },
    medium_03_softener_text: {
      id: 'medium_03_softener_text',
      defaultMessage: "Greensand",
      description: '',
    },
    medium_05_softener_text: {
      id: 'medium_05_softener_text',
      defaultMessage: "Crystal Right CR 200",
      description: '',
    },
    medium_06_softener_text: {
      id: 'medium_06_softener_text',
      defaultMessage: "Activated carbon",
      description: '',
    },
    medium_07_softener_text: {
      id: 'medium_07_softener_text',
      defaultMessage: "Multilayer activated carbon+sand+gravel",
      description: '',
    },
    medium_08_softener_text: {
      id: 'medium_08_softener_text',
      defaultMessage: "Crystal Right CR 100",
      description: '',
    },
    medium_09_softener_text: {
      id: 'medium_09_softener_text',
      defaultMessage: "Filter AG Plus",
      description: '',
    },
    medium_10_softener_text: {
      id: 'medium_10_softener_text',
      defaultMessage: "PA 202",
      description: '',
    },
    medium_11_softener_text: {
      id: 'medium_11_softener_text',
      defaultMessage: "Ecomix A",
      description: '',
    },
    medium_12_softener_text: {
      id: 'medium_12_softener_text',
      defaultMessage: "Nitro",
      description: '',
    },
    single_bottle_text: {
      id: 'single_bottle_text',
      defaultMessage: "Pojedynczy",
      description: '',
    },
    singlefilter_bottle_text: {
      id: 'singlefilter_bottle_text',
      defaultMessage: "Pojedynczy filtr",
      description: '',
    },
    doubleparallel_bottle_text: {
      id: 'doubleparallel_bottle_text',
      defaultMessage: "Podwójny równoległy",
      description: '',
    },
    doublealternative_bottle_text: {
      id: 'doublealternative_bottle_text',
      defaultMessage: "Podwójny alternatywny",
      description: '',
    },
    doublefilter_bottle_text: {
      id: 'doublefilter_bottle_text',
      defaultMessage: "Podwójny filtr",
      description: '',
    },
    tripleparallel_bottle_text: {
      id: 'tripleparallel_bottle_text',
      defaultMessage: "Potrójny równoległy",
      description: '',
    },
    triplealternative_bottle_text: {
      id: 'triplealternative_bottle_text',
      defaultMessage: "Potrójny alternatywny",
      description: '',
    },
    triplefilter_bottle_text: {
      id: 'triplefilter_bottle_text',
      defaultMessage: "Potrójny filtr",
      description: '',
    },
    search_box_device_list: {
      id: 'search_box_device_list',
      defaultMessage: "Search",
      description: '',
    },
  });
  return messages;
}



// WEBPACK FOOTER //
// ./src/components/Popup/Messages.js